/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ProfileTabPanel = (props) => {
    
    const { children, value, index, ...other } = props;
    
    return (
        <div
            role='tabpanel'
            className='profile-tabpanel'
            hidden={value !== index}
            id={`profile-tabpanel-${index}`}
            aria-labelledby={`profile-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export { ProfileTabPanel };
